
import React, { Component } from 'react';
import '../../css/HorizontalScroll.css';
import PrePostStockPrice from './PrePostStockPrice';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import PrePostCommodityPrice from './PrePostCommodityPrice';
import { callService } from '../../service/PrePostService';

class HorizontalScroll extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        console.log('Horizontalscroll');
        this.interval = setInterval(() => { callService() }, 1000 * 10 * 1); //5 mins
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }


    getSettings() {
        let screenWidth = window.screen.width;
        console.log('screenwidth', screenWidth);
        let settings, slidesToShow, slidesToScroll;
        if (screenWidth <= 500) {
            slidesToShow = 2;
            slidesToScroll = 2;
        } else {
            slidesToShow = 6;
            slidesToScroll = 6;
        }
        settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            arrows: true,
            autoplay: true,
            speed: 10000,
            autoplaySpeed: 10000,
        };
        return settings;
    }

    render() {
        let settings = this.getSettings();

        return (
            <>
                {/* <Row style={{backgroundColor: 'green'}}> */}
                <Slider {...settings}>
                    <div>
                        <PrePostStockPrice symbolName={'DIA (US Index ETF)'} ticker={'DIA'} bgc={'#d9d2e9'} />
                    </div>
                    <div>
                        <PrePostStockPrice symbolName={'SPY (US Index ETF)'} ticker={'SPY'} bgc={'#d9d2e9'} />
                    </div>
                    <div>
                        <PrePostStockPrice symbolName={'QQQ (US Index ETF)'} ticker={'QQQ'} bgc={'#d9d2e9'} />
                    </div>

                    <div>
                        <PrePostCommodityPrice symbolName={'VIX (US)'} ticker={'^VIX'} bgc={'#D8BFD8'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Russell 2K (US)'} ticker={'^RUT'} bgc={'#D8BFD8'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'US Dollar Index (US)'} ticker={'DX-Y.NYB'} bgc={'#D8BFD8'} />
                    </div>

                    <div>
                        <PrePostCommodityPrice symbolName={'US 5Y (Bonds)'} ticker={'^FVX'} bgc={'#F0E68C'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'US 10Y (Bonds)'} ticker={'^TNX'} bgc={'#F0E68C'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'US 30Y (Bonds)'} ticker={'^TYX'} bgc={'#F0E68C'} />
                    </div>
                    {/* <div>
                            <PrePostCommodityPrice symbolName={'Treasury 13 Week (Bonds)'} ticker={'^IRX'} />
                        </div> */}


                    <div>
                        <PrePostCommodityPrice symbolName={'Crude (Oil)'} ticker={'CLUSD'} bgc={'lightgreen'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Brent (Oil)'} ticker={'BZUSD'} bgc={'lightgreen'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Heating (Oil)'} ticker={'HOUSD'} bgc={'lightgreen'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Nat Gas (Gas)'} ticker={'NGUSD'} bgc={'lightgreen'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'RBOB Gas (Gas)'} ticker={'RBUSD'} bgc={'lightgreen'} />
                    </div>

                    <div>
                        <PrePostCommodityPrice symbolName={'Gold (Metal)'} ticker={'GCUSD'} bgc={'lightgrey'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Silver (Metal)'} ticker={'SIUSD'} bgc={'lightgrey'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Copper (Metal)'} ticker={'HGUSD'} bgc={'lightgrey'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Platinum (Metal)'} ticker={'PLUSD'} bgc={'lightgrey'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Palladium (Metal)'} ticker={'PAUSD'} bgc={'lightgrey'} />
                    </div>

                    <div>
                        <PrePostCommodityPrice symbolName={'USD/EUR (FX)'} ticker={'USDEUR'} bgc={'#A9A9A9'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'USD/JPY (FX)'} ticker={'USDJPY'} bgc={'#A9A9A9'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'USD/GBP (FX)'} ticker={'USDGBP'} bgc={'#A9A9A9'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'USD/CAD (FX)'} ticker={'USDCAD'} bgc={'#A9A9A9'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'USD/AUD (FX)'} ticker={'USDAUD'} bgc={'#A9A9A9'} />
                    </div>

                    <div>
                        <PrePostCommodityPrice symbolName={'Bitcoin (Crypto)'} ticker={'BTCUSD'} bgc={'#ADD8E6'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Ethereum (Crypto)'} ticker={'ETHUSD'} bgc={'#ADD8E6'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'XRP (Crypto)'} ticker={'XRPUSD'} bgc={'#ADD8E6'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Litecoin (Crypto)'} ticker={'LTCUSD'} bgc={'#ADD8E6'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'Bitcoin Cash (Crypto)'} ticker={'BCHUSD'} bgc={'#ADD8E6'} />
                    </div>

                    <div>
                        <PrePostCommodityPrice symbolName={'Nikkei (Asia)'} ticker={'^N225'} bgc={'#F5DEB3'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'HSI (Asia)'} ticker={'^HSI'} bgc={'#F5DEB3'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'ASX 200 (Asia)'} ticker={'^AXJO'} bgc={'#F5DEB3'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'KOSPI (Asia)'} ticker={'^KS11'} bgc={'#F5DEB3'} />
                    </div>

                    <div>
                        <PrePostCommodityPrice symbolName={'DAX (EU)'} ticker={'^GDAXI'} bgc={'#DDA0DD'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'FTSE (EU)'} ticker={'^FTSE'} bgc={'#DDA0DD'} />
                    </div>
                    <div>
                        <PrePostCommodityPrice symbolName={'CAC (EU)'} ticker={'^FCHI'} bgc={'#DDA0DD'} />
                    </div>
                </Slider>
                {/* </Row> */}
            </>
        )
    }
}
export default HorizontalScroll;

